import styled from '@emotion/styled'

import Divider from '@segment/matcha/components/Divider'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  heading: `Use AI to turn every customer interaction into a unique customer experience`,
}

const BuildIntelligentCustomerEngagement = () => {
  return (
    <StyledSectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.heading}
          </CopyText.Heading>
        </CopyTextBase>
      </Section.Copy>
      <StyledDivider />
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
    padding-top: 40px;
    padding-bottom: 40px;
  }

  ${Section.Copy} {
    max-width: 844px;
  }
`

const StyledDivider = styled(Divider)`
  margin-top: 80px;
`

export default BuildIntelligentCustomerEngagement
